import AttributesView from './AttributesView'
import UnAttributesView from './UnAttributesView'
import CounterController from './CounterController'
import Counter from './Counter'
import PriceCalculator from './PriceCalculator'
import UnCounter from './UnCounter'
import UnAttributesViewProduct from './UnAttributesViewProduct'
import RozetkaPayparts from './Payparts'

export default function install(Vue) {
  Vue.component('AttributesView', AttributesView)
  Vue.component('UnAttributesView', UnAttributesView)
  Vue.component('CounterController', CounterController)
  Vue.component('Counter', Counter)
  Vue.component('PriceCalculator', PriceCalculator)
  Vue.component('UnAttributesViewProduct', UnAttributesViewProduct)
  Vue.component('UnCounter', UnCounter)
  Vue.component('RozetkaPayparts', RozetkaPayparts)
}
